import { createAction, createAsyncAction } from 'typesafe-actions';
import { FetchModels } from '../types';

export const POST_REVIEW = createAsyncAction(
  'reviews/POST_REVIEW/request',
  'reviews/POST_REVIEW/success',
  'reviews/POST_REVIEW/failure',
  'reviews/POST_REVIEW/cancel',
)<FetchModels.PostReviewData, unknown, FetchModels.PostReviewRequestError, void>();

export const POST_REVIEW_RESET = createAction('reviews/POST_REVIEW/reset')();
